import { render, staticRenderFns } from "./bnf.vue?vue&type=template&id=4b9f4026"
import script from "./bnf.vue?vue&type=script&lang=js"
export * from "./bnf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports